/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DOMAIN } from '../../config';
import { removeFromStorage } from '../../utils/webStorage';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import { useAppDispatch } from '../../app/hooks';
import { openChat } from '../../store/brokers/partners/chats/ChatsUISlice';
import Navigation from './Navigation';
import ThemeToggle from '../../shared/theme-toggle';
import NewChatModal from '../../components/new-chat/NewChatModal';
import { useTheme } from '../../theme-context';
import { AdminGuard, PartnerGuard } from '../../guards/RolesGuard';
import { useConfigFirstRunQuery } from '../../store/chatbox/chatboxApi';

interface ISidebar {
  onClickShowModal: () => void;
  onClickOpenChat: (id?: string, action?: any) => void;
  isMobile?: boolean
  userInfoData?: any;
  onClickInvite: () => void;
}

const Sidebar = ({
  onClickShowModal,
  onClickOpenChat,
  onClickInvite,
  userInfoData,
  isMobile = false
}: ISidebar) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [search, setSearch] = useState<string>();
  const { data: dataConfig } = useConfigFirstRunQuery();
  const { data: userData } = useGetCurrentUserQuery();

  const handleLogout = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('roles');
    removeFromStorage('user');
    window.location.reload();
    navigate('/auth');
  }

  const onClickPage = (page: string) => {
    navigate(page)
  }

  const onChangePageSearch = (value: string) => {
    setSearch(value)
  }

  const onClickManageUsers = () => {
    navigate('/claire-2');
    dispatch(openChat({ data: [] }));
  };

  return (
    <div className={`${isMobile ? 'w-64 h-full flex flex-col bg-white dark:bg-[#2a2a2a]' : 'hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 border-r-1 border-r dark:border-borderColor-darkMode dark:bg-bgColor-darkMode'}`}>
      <div className='flex flex-row items-center justify-between mb-6 mt-4 px-3 sm:px-4'>
        <div className='flex flex-row items-center'>
          <img
            className='w-10 h-10 sm:w-12 sm:h-12 bg-black dark:bg-white rounded-full mr-2'
            src={userData?.data?.profileUrl || '/assets/layout/profile-icon.svg'}
            alt='main photo'
          />
          <div className='text-left'>
            <div title={userInfoData} className='text-sm sm:text-base font-normal text-primary-light dark:text-primary-dark truncate max-w-[120px] overflow-hidden whitespace-nowrap'>
              {userInfoData}
            </div>
            <p className='text-xs sm:text-sm text-primary-light dark:text-primary-dark'>{PartnerGuard() ? 'Administrator' : 'Member'}</p>
          </div>
        </div>
        <div className='flex flex-row items-center justify-end'>
          <div className='cursor-pointer hover:opacity-80' onClick={() => onClickPage('/settings')}>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/settings-icon-white.svg' : '/assets/navigation-icons/sidebar/settings-icon.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2'
            />
          </div>
          <div className='cursor-pointer hover:opacity-80' onClick={handleLogout}>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/logout-icon-white.svg' : '/assets/navigation-icons/sidebar/logout-icon.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]'
            />
          </div>
        </div>
      </div>

      {(AdminGuard() && location?.pathname !== '/get-started') &&
        <div className='border-b py-3 px-3 sm:px-4'>
          <div
            onClick={onClickManageUsers}
            className='flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3'>
            <img
              src={theme === 'dark' ? '/svg/new-question-white.svg' : '/svg/new-question.svg'}
              className='object-contain w-[23px] h-[23px] mr-3'
            />
            <p className='text-sm sm:text-base dark:text-primary-darkMode'>Manage Users</p>
          </div>
        </div>
      }
      <div className='flex flex-col flex-grow pt-2 overflow-y-auto'>
        <nav data-qa='navigation' className='flex-1 px-3 sm:px-4 pb-4'>
          <Navigation search={search} />
        </nav>
      </div>

      <div className='border-t px-3 py-3'>
        {/* <div className='!rounded-lg bg-[#F5F5F5] dark:bg-black border border-[#e9eaeb] p-3 cursor-pointer hover:opacity-80 '>
          <div className='flex flex-row items-center mb-2'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/add-icon-white.svg' : '/assets/navigation-icons/sidebar/add-icon.svg'}
              className='object-contain w-6 h-6 sm:w-[20px] sm:h-[20px] mr-2'
            />
            <p className='font-semibold text-sm dark:text-primary-dark sm:text-base'>Add agent</p>
          </div>
          <p className='text-xs sm:text-sm dark:text-primary-dark'>Find more about our upcoming agents and deals.</p>
        </div> */}
        {(AdminGuard() && dataConfig?.data?.trialPeriod && dataConfig?.data?.firstRun) &&
          <div onClick={() => dataConfig?.data?.inviteCount < 5 && onClickInvite()} className='my-3 bg-[#00330F] rounded-md px-2 py-3 cursor-pointer hover:opacity-80'>
            <div className='flex flex-row items-center mb-8'>
              <img src={'/assets/navigation-icons/sidebar/add-icon-white.svg'} className='object-contain w-[23px] mr-2' />
              <p className='text-white text-lg'>Invite Friends</p>
            </div>
            <p className='text-sm text-white'>Invite a friend to try Claire.</p>
            <p className='text-sm text-white'>{5 - Number(dataConfig?.data?.inviteCount || 0)} out 5 invitations left</p>
          </div>
        }
        <div className='my-4 sm:my-5'>
          <ThemeToggle />
        </div>

        <img
          src={theme === 'dark' ? '/assets/navigation-icons/sidebar/sidebar-icon-white.svg' : '/assets/navigation-icons/sidebar/sidebar-icon.svg'}
          className='object-contain h-10 sm:h-[45px] my-2'
        />
      </div>

    </div>
  )
}

export default Sidebar;